module.exports = __webpack_public_path__ + "static/media/icon_instrument_electric_guitar.b9441f81.svg";